const environments = {
    local: {
        AWS_REGION: 'us-west-2',
        AWS_ACCESS_KEY_ID: 'AKIAVEBKBTGZVVJJGEAI',
        AWS_SECRET_ACCESS_KEY: '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',
        COGNITO_REGION: 'us-west-2',
        USER_POOL_ID: 'us-west-2_sXZroURnY',
        CLIENT_ID: 'va9vcsno78h85t5aqhqm3tnks',
        OAUTH_DOMAIN: 'dgv2-saml-sso.auth.us-west-2.amazoncognito.com',
        UI_WRAPPER_LAMBDA_FUNCTION: 'DGV2-UIWrapper',
        LOGIN_SP_COMMAND: 'DGV2-SSO-SignIn',
        DASHBOARD_SP_COMMAND: 'DGV2-SSO-Dashboard',
        LOGOUT_SP_COMMAND: 'DGV2-SSO-Logout',
    },
    dev: {
        AWS_REGION: 'us-west-2',
        AWS_ACCESS_KEY_ID: 'XXXXXXXXXXXX',
        AWS_SECRET_ACCESS_KEY: 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX',
        COGNITO_REGION: '',
        USER_POOL_ID: '',
        CLIENT_ID: '',
        OAUTH_DOMAIN: ''
    },
    uat: {
        AWS_REGION: 'us-west-2',
        AWS_ACCESS_KEY_ID: 'XXXXXXXXXXXX',
        AWS_SECRET_ACCESS_KEY: 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX',
        COGNITO_REGION: '',
        USER_POOL_ID: '',
        CLIENT_ID: '',
        OAUTH_DOMAIN: ''
    },
    prod: {
        AWS_REGION: 'us-west-2',
        AWS_ACCESS_KEY_ID: 'XXXXXXXXXXXX',
        AWS_SECRET_ACCESS_KEY: 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX',
        COGNITO_REGION: '',
        USER_POOL_ID: '',
        CLIENT_ID: '',
        OAUTH_DOMAIN: ''
    }
};

export default environments;
